import React from 'react';
import RelatorioSugestaoCompra from '../components/RelatorioSugestaoCompra';
import { Row, Col, Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

function SugestaoPage() {
  return (
    <div className="content-wrapper">
        <h2>Sugestão de Compra</h2>
        <Breadcrumb style={{ marginBottom: 16 }}>
          <Breadcrumb.Item>
            <Link to="/">Início</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Sugestão de Compra</Breadcrumb.Item>
        </Breadcrumb>
        <Row>
        <Col
          xs={0} // Esconde em dispositivos pequenos
          sm={0} // Esconde em dispositivos médios
          md={24} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <RelatorioSugestaoCompra />
        </Col>
        <Col
          xs={24} // Esconde em dispositivos pequenos
          sm={24} // Esconde em dispositivos médios
          md={0} // Mostra em dispositivos maiores ou iguais a 'md'
        >
          <RelatorioSugestaoCompra />
        </Col>
      </Row>
    </div>
  );
}

export default SugestaoPage;